const ready = (callback) => {
  if (
    // eslint-disable-next-line operator-linebreak
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
  ) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
};

export default ready;
